var _excluded = ["children"],
  _excluded2 = ["messages", "locale"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { DEFAULT_LOCALE, DEFAULT_TIMEZONE, formatMessageString } from '@prezly/theme-kit-intl';
import React, { createContext, useCallback, useContext } from 'react';
var context = /*#__PURE__*/createContext({
  locale: 'en',
  locales: [DEFAULT_LOCALE],
  defaultLocale: DEFAULT_LOCALE,
  messages: {},
  timezone: DEFAULT_TIMEZONE
});
export function IntlProvider(_ref) {
  var {
      children
    } = _ref,
    value = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(context.Provider, {
    value: value
  }, children);
}
export function useIntl() {
  var _useContext = useContext(context),
    {
      messages,
      locale
    } = _useContext,
    value = _objectWithoutProperties(_useContext, _excluded2);
  var formatMessage = useCallback((descriptor, values) => formatMessageString(locale, descriptor, messages, values), [locale, messages]);
  return _objectSpread(_objectSpread({}, value), {}, {
    locale,
    messages,
    formatMessage
  });
}